import styled, { css } from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  position: relative;
  display: grid;
  border-radius: 24px 24px 0px 0px;
  min-height: calc(var(--app-height) - 72px);

  ${({ hasBreadcrumb, theme }) =>
    hasBreadcrumb &&
    css`
      grid-template-rows: min-content auto;
      background-color: ${theme.colors.neutral.white};
      padding-bottom: 76px;
    `}

  ${media.greaterThan("medium")`
    grid-gap: ${(props) => (props.gap ? props.gap : "32px")};
    padding-bottom: 0;
    background: transparent;
  `}
`;

export const BroadCramb = styled.div``;
